import { HttpInterceptorFn } from '@angular/common/http';

export const accountIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api/v1/users/send-finish-business-setup-notification')) {
    return next(req);
  }

  if (req.url.includes('/api/v1/users/accounts')) {
    return next(req);
  }

  // // Исключение для запросов к api/v1/reports/{id}
  // if (/\/api\/v1\/reports\/\d+/.test(req.url)) {
  //   return next(req);
  // }

  // // Исключение для запросов к api/aml-scans/{uuid} (используется на странице transaction-report)
  // if (/\/api\/aml-scans\/.+/.test(req.url)) {
  //   return next(req);
  // }

  const appXAccountId = localStorage.getItem('app-x-account-Id');
  if (appXAccountId) {
    req = req.clone({
      setHeaders: { 'x-account-Id': appXAccountId }
    });
  }

  return next(req);
};
